import { UseQueryResult, useQuery } from 'react-query';
import axios, { AxiosError } from 'axios';
import { auth } from '@olo-web/utils/google/firebase';

type GetUserByEmailParams = {
  email: string;
  merchantId?: string;
};

export const getUserByEmail = async ({
  email,
  merchantId,
}: GetUserByEmailParams): Promise<IThemeUserRecord> => {
  try {
    const idToken = await auth().currentUser.getIdToken();
    const { data } = await axios.post(
      `/api/users/get-by-email`,
      { email, merchantId },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? error?.message);
  }
};

export const useGetUserByEmail = (
  email: string,
  merchantId?: string
): UseQueryResult<IThemeUserRecord, AxiosError> => {
  return useQuery(
    ['theme-auth-user', email, merchantId],
    () => getUserByEmail({ email, merchantId }),
    {
      staleTime: 100000,
      enabled: !!email,
      retry: 0,
    }
  );
};
